module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "600px",
      "margin": "0 auto",
      "display": "block"
    },
    attrs: {
      "id": "email"
    }
  }, [_c('header', {
    staticClass: "header-email"
  }, [_c('div', {
    staticClass: "brand",
    staticStyle: {
      "border-bottom": "1px solid rgb(204,204,204)",
      "padding-bottom": "6px"
    }
  }, [_c('figure', {
    staticClass: "logo-sistema",
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "width": "51%"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imagens/logo-domus.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "site",
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "rgb(0,102,153)",
      "font-size": "13px"
    },
    attrs: {
      "href": "https://habix.agehab.ms.gov.br/controledesaldo/",
      "target": "_blank"
    }
  }, [_vm._v("\n              habix.agehab.ms.gov.br/controledesaldo\n            ")])])]), _vm._v(" "), _c('section', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "width": "100%",
      "margin": "10px 0",
      "text-align": "right"
    }
  }, [_c('strong', {
    staticStyle: {
      "display": "block",
      "font-size": "22px",
      "font-weight": "600"
    }
  }, [_vm._v("Situação da solicitação")]), _vm._v("\n         de Jose Carlos Balabuch\n      ")])]), _vm._v(" "), _c('main', [_c('h1', {
    staticStyle: {
      "font-size": "21px",
      "color": "rgb(128, 5, 34)",
      "margin": "15px 0",
      "font-weight": "600"
    }
  }, [_vm._v("Olá, Bárbara")]), _vm._v(" "), _c('div', {
    staticClass: "status-reservado",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "17px",
      "line-height": "24px"
    }
  }, [_vm._v("\n\n          A solicitação de "), _c('strong', [_vm._v("Jose Carlos Balabuch ")]), _vm._v("foi para a situação de "), _c('strong', [_vm._v("reservado")]), _vm._v(" pela AGEHAB\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "solicitar-cancelamento",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "17px",
      "line-height": "24px"
    }
  }, [_vm._v("\n          O Agente financeiro solicitou cancelamento para a solitação de "), _c('strong', [_vm._v("Jose Carlos Balabuch ")]), _vm._v(".\n          "), _c('br'), _vm._v("\n          Motivo: Houve deistencia do financiamento por parte do solicitante.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "status-solicitado",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('p', [_vm._v("\n          Foi criada uma solicitação para "), _c('strong', [_vm._v("Evelyn Chiavagatti")]), _vm._v(" pelo agente financeiro Diogonc\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "status-reservado",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('p', [_vm._v("\n          A solicitação de "), _c('strong', [_vm._v("Jose Carlos Balabuch")]), _vm._v(" foi "), _c('strong', [_vm._v(" Autorizado pagamento")]), _vm._v(" pela AGEHAB\n        ")])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#800522",
      "border": "none",
      "border-radius": "3px",
      "color": "#fff",
      "padding": "10px",
      "width": "100%",
      "margin": "10px 0",
      "font-size": "16px",
      "display": "block",
      "cursor": "pointer"
    }
  }, [_vm._v("ver solicitação")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "font-size": "15px",
      "font-weight": "600"
    }
  }, [_vm._v("\n      Até a próxima!")])]), _vm._v(" "), _c('footer', {
    staticStyle: {
      "padding": "10px 0",
      "font-size": "11px",
      "color": "rgb(102,102,102)",
      "line-height": "16px",
      "font-family": "Arial,sans-serif",
      "border-top": "1px solid rgb(204,204,204)",
      "padding-top": "6px"
    }
  }, [_vm._v("\n      Observação: Este é um e-mail de notificação e foi gerado automaticamente. Por favor, não responda esta mensagem.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c78cc8d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email/Email.vue
// module id = 1140
// module chunks = 1